import { atom } from 'recoil';

export default atom({
  key: 'speedState',
  default: 1,
});
